import React from 'react';

const SIDEBAR_WIDTH = 260;
const NAVBAR_HEIGHT = 60;
const TOP_GAP = 12; // space between navbar and sidebar

const ConsultantSidebar = ({ section, setSection /* keep other props if used elsewhere */ }) => {
  const item = (key, label) => (
    <button
      onClick={() => setSection(key)}
      style={{
        display: 'block',
        width: '100%',
        padding: '10px 12px',
        textAlign: 'left',
        background: section === key ? '#e8f0ff' : 'transparent',
        border: 'none',
        cursor: 'pointer'
      }}
    >
      {label}
    </button>
  );

  return (
    <aside
      style={{
        position: 'fixed',
        top: NAVBAR_HEIGHT + TOP_GAP,
        left: 0,
        width: SIDEBAR_WIDTH,
        height: `calc(100vh - ${NAVBAR_HEIGHT + TOP_GAP}px)`,
        borderRight: '1px solid #eee',
        padding: 12,
        background: '#fff',
        overflow: 'auto',
        zIndex: 900
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 12 }}>Consultant</div>
      {item('clients', 'Client List')}
      {item('payments', 'Payment Info')}
    </aside>
  );
};

export default ConsultantSidebar;